export default "__VITE_ASSET__Cnge3WkX__"